import {
    EnumButtonName,
    EnumFeature,
    EnumScreenName,
    EventProperties,
} from '@calm/evexia-analytics';
import { Close } from '@mui/icons-material';
import commonMessages from '@rhg/lang/messages/common';
import { IconButton, SxProps, Theme } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import { useIntl } from 'react-intl';

const styleCloseButton = {
    color: (theme: Theme) =>
        theme.palette.mode === 'light' ? 'action.active' : 'primary.main',
    zIndex: 1,
};
const styleCloseButtonContained = {
    borderRadius: '50%',
    backgroundColor: (theme: Theme) =>
        theme.palette.mode === 'light' ? 'mask.white.80p' : 'mask.black.40p',
};
const styleCloseButtonFullScreen = {
    color: 'primary.main',
};

export type DialogCloseButtonVariant = 'flat' | 'contained';
export const DialogCloseButtonVariant = {
    Flat: 'flat' as DialogCloseButtonVariant,
    Contained: 'contained' as DialogCloseButtonVariant,
};
export interface DialogCloseButtonProps {
    sx?: SxProps<Theme>;
    variant?: DialogCloseButtonVariant;
    trackButton?: EnumButtonName;
    trackScreen?: EnumScreenName;
    trackFeature?: EnumFeature;
    trackProps?: EventProperties;
    isFullScreen?: boolean;
    onClick: () => void;
}

export function DialogCloseButton({
    sx,
    trackButton = 'Close',
    trackScreen,
    trackFeature,
    trackProps,
    isFullScreen,
    variant = 'contained',
    onClick,
}: DialogCloseButtonProps) {
    const { formatMessage } = useIntl();

    return (
        <IconButton
            sx={sxAppend(
                styleCloseButton,
                variant === 'contained' && styleCloseButtonContained,
                isFullScreen && styleCloseButtonFullScreen,
                sx
            )}
            aria-label={formatMessage(commonMessages['common.dismiss_dialog'])}
            onClick={onClick}
            size={isFullScreen ? 'medium' : 'small'}
            trackButton={trackButton}
            trackScreen={trackScreen}
            trackFeature={trackFeature}
            trackProps={trackProps}
        >
            <Close />
        </IconButton>
    );
}
